export const API = process.env.REACT_APP_API_URL;
export const API_SHIPPING = process.env.REACT_APP_API_SHIPPING_URL;
